import { Button, Fields, Link } from '@ets-global/b2c-website-ui';
import { Form, Formik } from 'formik';
import { func } from 'prop-types';
import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import useYup from '../../hooks/useYup';
import { paths } from '../../paths';
import ErrorMessage from '../Base/ErrorMessage/ErrorMessage';

const Login = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { Yup } = useYup();
  const validationSchema = Yup.object().shape({
    username: Yup.string().email().required(),
    password: Yup.string().required(),
  });

  return (
    <Fragment>
      <Formik
        initialValues={{ username: '', password: '', rememberMe: false }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        render={({ errors, isSubmitting }) => {
          return (
            <Form className="login-panel__form">
              <ErrorMessage>{errors.form}</ErrorMessage>
              <Fields.FormikFastField
                id={'username'}
                name={'username'}
                component={Fields.TextField}
                label={t('login.label.username')}
                autoComplete={'username'}
                required={true}
              />
              <Fields.FormikFastField
                id={'password'}
                name={'password'}
                component={Fields.PasswordField}
                label={t('login.label.password')}
                autoComplete={'password'}
                required={true}
              />
              <Fields.FormikFastField
                id={'rememberMe'}
                name={'rememberMe'}
                component={Fields.CheckboxField}
                label={t('login.label.remember-me')}
                autoComplete={'rememberMe'}
              />
              <Button
                className={'form__button form__submit button'}
                type={'submit'}
                loading={isSubmitting}
                aria-label={t('login.label.submit')}
              >
                <Trans>login.label.submit</Trans>
              </Button>
            </Form>
          );
        }}
      />
      <Link
        to={paths.FORGOTTEN_PASSWORD}
        className={'login-panel__forgotten-password'}
        aria-label={t('login.link.forgotten-password')}
      >
        <Trans>login.link.forgotten-password</Trans>
      </Link>
    </Fragment>
  );
};

Login.propTypes = {
  onSubmit: func.isRequired,
};

export default Login;
